
import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from '../../hooks/useForm';
import * as ActionTypes from '../actions/actionTypes'
import { CURRENT_INVOICE } from '../../GB_App/formSections/itemsTab/copyRepElement';

const createPayload=(invoiceId,merchandiseId,tableName)=>{
  return (params)=> ({
    "invoices": [
            {
                "invoiceId": invoiceId,
                "lineItems": [
                    {
                        "merchandiseId":merchandiseId,
                        "invoiceId":invoiceId,
                        [`${tableName}`]: [
                            {
                                ...params,
                                "type": "SELLER"
                            }
                        ]
                    }
                ]
            }
        ]
  })
}
export const useMultipleMerchandiseItem=({tableName,...rest})=>{
 const {isLoading,saveForm,deleteForm}=useForm("")
 const dispatch = useDispatch();
 const merchandiseListByInvoiceId = useSelector(state=>state.InvoicesReducer?.lineItems?.[rest?.invoiceId])
 const merchandiseList = useSelector(state=>state.InvoicesReducer?.lineItems)
 
 const payload=createPayload( rest.invoiceId,rest.merchandiseId,tableName)
  const AddItem = useCallback(async({params={},callback}) => {
     try{
        const response=await saveForm(payload({id:tableName=='containers' ? " ":"", ...params}))
        if(response){
            dispatch({
                type: ActionTypes.ADD_MERCHANDISE_DOC_BY_ID,
                payload:{id:response.responseMessage,...rest,...params},
                meta:{tableName}
            })
            callback && callback({id:response.responseMessage,...rest})
        }
     }
     catch(e){

     }
  }, [rest.invoiceId,rest.merchandiseId]);

  const deleteItem = useCallback(async(id, callback) => {
    try{
         const response=await deleteForm(payload({id}))
         if(response)
         dispatch({
            type: ActionTypes.DELETE_MERCHANDISE_DOC_BY_ID,
            payload:{id,...rest},
            meta:{tableName}
        })
        callback && dispatch(callback())      
     }
     catch(e){

     }
 }, [rest.invoiceId,rest.merchandiseId]);

 const updateItem = useCallback((id,params) => {
    try{
        dispatch({
            type:ActionTypes.UPDATE_MERCHANDISE_DOC_BY_ID,
            payload:{...params,...rest,id},
            meta:{tableName:tableName}
        })
    }
    catch{

    }
 }, [rest.invoiceId,rest.merchandiseId]);

 const saveItem = useCallback(async(params) => {
    try{
        const response=await saveForm(payload(params),false)
    }
    catch{

    }
 }, [saveForm]);


    const AddCopyItem = useCallback(async (copyItemDetails) =>{
        const {tabName, params, ...rest} = copyItemDetails
        try{
            const request = createPayload(rest?.invoiceId, rest?.merchandiseId, tableName=tabName)({id:tabName=='containers' ? " ":"", ...params})
            const response=await saveForm(request)
            if(response){
                return {id:response?.responseMessage, ...params, ...rest}
            }
        }catch(e){}
    },[saveForm])


    const getPromiseList=(copyFor,payload)=>{
        let multipleSaveRequest = null
        if(copyFor===CURRENT_INVOICE){
            let merchandiseIds = merchandiseListByInvoiceId?.filter(itm=>itm?.merchandiseId!==rest?.merchandiseId)
            multipleSaveRequest = merchandiseIds?.map(itm=>AddCopyItem({
                tabName:tableName,
                params:payload,
                invoiceId:itm?.invoiceId, 
                merchandiseId:itm?.merchandiseId
            }))
        }else{
            let merchandiseIds = Object.values(merchandiseList)?.reduce((prev, merchList) => {
                  let filteredList = merchList?.filter((i) => i?.merchandiseId !== rest?.merchandiseId);
                  return [...prev, ...filteredList]
            },[])
            multipleSaveRequest = merchandiseIds?.map(itm=>AddCopyItem({
                tabName:tableName,
                params:payload,
                invoiceId:itm?.invoiceId, 
                merchandiseId:itm?.merchandiseId
            }))
        }
        return multipleSaveRequest
    }

    const copyData = async (copyFor, payload) => {
        const multipleSaveRequest = getPromiseList(copyFor,payload)
        const response = await Promise.all(multipleSaveRequest)
        if(response){
            dispatch({
                type: ActionTypes.MASS_UPDATE_REPEATABLE_ELEMENTS,
                payload: response,
                meta:{tableName:tableName}
            })
        }
    }



  return {isLoading,AddItem,deleteItem,updateItem,saveItem,copyData}
} 